import React, { useEffect, useState } from "react";
import logo from "../../../assets/Logo/FBX_2024_alone.svg";
import "./supportAnnouncement.style.scss";

const STORAGE_KEY = "FBX_HIDE_CUSTOMER_SUPPORT_ANNOUNCEMENT";

const SupportAnnouncement = ({ show = false }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!show) {
            setVisible(false);
            return;
        }

        try {
            setVisible(localStorage.getItem(STORAGE_KEY) !== "Yes");
        } catch {
            setVisible(true);
        }
    }, [show]);

    const hideThisTime = () => {
        setVisible(false);
    };

    const hideForGood = () => {
        try {
            localStorage.setItem(STORAGE_KEY, "Yes");
        } catch {}
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="support-announcement-backdrop" role="dialog" aria-modal="true">
            <div className="support-announcement">
                <div className="support-announcement__brand">
                    <img src={logo} alt="FBX" />
                    <div>
                        <h2>Customer Support Button</h2>
                    </div>
                </div>

                <div className="support-announcement__body">
                    <div className="support-announcement__button-preview">
                        <span>?</span>
                    </div>

                    <div className="support-announcement__copy">
                        <p>
                            The blue button in the bottom-right corner now gives you quick access to
                            answers for common FBX questions.
                        </p>
                        <p>
                            Open <strong>Common Questions</strong> for instant help, or use{" "}
                            <strong>Customer Support</strong> to connect directly when you need a person
                            to answer a question.
                        </p>
                    </div>
                </div>

                <div className="support-announcement__highlights">
                    <div>
                        <strong>Fast Answers</strong>
                        <span>Find common workflow help without leaving the page.</span>
                    </div>
                    <div>
                        <strong>Real Support</strong>
                        <span>Send a question when you need someone to look into it.</span>
                    </div>
                    <div>
                        <strong>Always There</strong>
                        <span>Look for the blue question button at the bottom-right.</span>
                    </div>
                </div>

                <div className="support-announcement__actions">
                    <button type="button" className="btn btn-outline-secondary" onClick={hideThisTime}>
                        Hide This Time
                    </button>
                    <button type="button" className="btn btn-primary" onClick={hideForGood}>
                        Hide for Good
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SupportAnnouncement;
